import { useEffect, useRef } from 'react';

const PageVisibilityWatcher = ({ delayMs = 10000, onReturn }) => {
  const lastHiddenTimeRef = useRef(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        lastHiddenTimeRef.current = Date.now();
      } else {
        const now = Date.now();
        const timeAway = now - (lastHiddenTimeRef.current || now);
        if (timeAway >= delayMs) {
          onReturn?.();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [delayMs, onReturn]);

  return null; // Non rende nulla, è solo un watcher
};

export default PageVisibilityWatcher;
